import ErrorBoundary from '@sber-site/sbercraft-nova-kit/components/ErrorBoundary';
import React from 'react';

import { sendToAnalytics } from './analytics/web-analytics';
import RetentionWidget from './RetentionWidget';

const handleError = () => {
    sendToAnalytics('retention_error', 'undefined');
};

export default function App({ preferences }) {
    return (
        <ErrorBoundary onError={() => handleError()}>
            <RetentionWidget {...preferences} />
        </ErrorBoundary>
    );
}
